import React, { ReactNode } from "react";

interface Props {
    topLeft?: ReactNode;
    bottomLeft?: ReactNode;
    bottomRight?: ReactNode;
    children?: ReactNode;
}

export default function ViewerOverlay({ topLeft, bottomLeft, bottomRight, children }: Props) {
    return (
        <div className="pointer-events-none absolute inset-0 z-20">
            {topLeft && (
                <div className="pointer-events-auto absolute left-4 top-4 flex items-center gap-2">
                    {topLeft}
                </div>
            )}
            <div className="pointer-events-auto absolute right-4 top-4 flex items-center gap-2">
                {children}
            </div>
            {bottomLeft && (
                <div className="pointer-events-auto absolute bottom-4 left-4 flex items-center gap-2">
                    {bottomLeft}
                </div>
            )}
            {bottomRight && (
                <div className="pointer-events-auto absolute bottom-4 right-4 flex items-center gap-2">
                    {bottomRight}
                </div>
            )}
        </div>
    );
}
